import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const LocationIdField = ({ errors, touched, darkMode, isEditMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.id && touched.id}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>ID</FormLabel>
                <Field
                    name="id"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Enter location ID"
                            label="ID *"
                            darkMode={darkMode}
                            isReadOnly={isEditMode}
                        />
                    )}
                />
                {isHovered && !isEditMode && (
                    <FieldToolTip
                        label="Enter a unique ID for this location"
                        ariaLabel="location-id-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError error={errors?.id} touched={touched?.id} />
        </FormControl>
    );
};

export default LocationIdField;
